var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SellHeader',{attrs:{"img_header":_vm.header_image,"header":"คำสั่งซื้อ","link_back":"sell/ordercustomermain"}}),_c('Confirm_customer_detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }